export default {
  // serverURI: 'http://123.206.198.189:3300/api',
  // serverURI: 'http://210.14.78.146:8600/api',
  //serverURI: 'http://119.3.15.153:8100/XF/api',
  // serverURI: 'http://119.3.15.153:8100/HJ/api',
  serverURI: 'http://119.3.15.153:8100/NGS/api',
  // serverURI: 'http://119.3.15.153:8600/api',
  // serverURI: 'http://119.3.15.153:8100/CTD/api',
  // serverURI: 'http://119.3.15.153:8100/HQYY/api',
  // serverURI: 'http://111.231.77.219:3400/YYGY/api',
  // serverURI: 'http://localhost:8080/api',
  wsUrl: "ws://localhost:9090",
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js